import React, { useState, useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";

import PreviewImage from "src/components/previewImage/PreviewImage";
import LogoService from "src/service/logoService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Update Logo",
  },
];

const validationSchema = yup.object({
  header_name: yup
    .string("Enter Header Name")
    .matches(/^[a-zA-Z ]+$/, "Header Name should only contain Alphabet")
    .min(2, "Header Name should be of minimum 2 characters in length")
    .max(30, "Header Name should be of maximum 30 characters in length")
    .required("Header Name is required"),
});

const UpdateDynamicLogo = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();

  const navigate = useNavigate();

  const [updatedriver_logo, setupdatedriver_logo] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPreviewImage(file);
    }
  };

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    header_name: "",
    logo: "",
    d_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetchDriverData = async () => {
      try {
        const res = await LogoService.getLogoList({
          id: param.id,
        });

        // Update the initialValues once data is fetched
        setInitialValues({
          id: param.id,
          header_name: res.data[0].header_name,
          logo: res.data[0].logo,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchDriverData();
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const formData = new FormData();
          formData.append("id", param.id);
          formData.append("header_name", values.header_name);
          formData.append("logo", previewImage);
          formData.append("d_by", sessionData.data.id);
          const res = await LogoService.updateLogo(formData);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/dynamiclogolist");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title="Update Logo" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Logo
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/dynamiclogolist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="header_name">
                Header Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="header_name"
                name="header_name"
                type="text"
                value={values.header_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.header_name && Boolean(errors.header_name)}
                helperText={touched.header_name && errors.header_name}
                variant="outlined"
                placeholder="Enter Header name"
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="logo">
                Upload Logo <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                accept="image/*"
                id="logo"
                name="logo"
                type="file"
                // onChange={handleFileChange}
                onChange={(event) => {
                  handleChange(event);
                  handleFileChange(event);
                  setupdatedriver_logo(event.target.files[0]);
                }}
                onBlur={handleBlur}
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              {!updatedriver_logo ? (
                <img
                  src={values.logo}
                  style={{ width: "200px", height: "200px" }}
                  alt="no img found"
                />
              ) : (
                <PreviewImage file={previewImage} />
              )}
            </Grid>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12} style={{ marginTop: "20px" }}>
            <Button color="primary" variant="contained" type="submit">
              Update
            </Button>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateDynamicLogo;
